// eslint-disable-next-line
import util from 'util';

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import * as Stripe from '@stripe/react-stripe-js';

const styles = theme => ({
});


/*
 * Show the "Pay Now" button if available
 *
 * Documentation: https://stripe.com/docs/stripe-js/react
 */
class PaymentButton extends React.Component {
  state = {
    balance: 0,
    paymentRequest: undefined,
    canMakePayment: false,
  }

  checkPayment = () => {
    if (!Boolean(this.props.stripe)) {
      return;
    }
    if (this.props.balance !== this.state.balance) {
      this.setState({balance : this.props.balance, canMakePayment: false});
      if (typeof(this.props.onDisabled) === 'function') {
        this.props.onDisabled();
      }
      if (this.props.balance > 0) {
        /* Creating payment */
        this.paymentRequest = this.props.stripe.paymentRequest({
          country: this.props.paymentProcessorId === "STRIPE_CA" ? 'CA' : 'US',
          currency: this.props.paymentProcessorId === "STRIPE_CA" ? 'cad' : 'usd',
          total: {
            label: 'Answering Service',
            amount: Math.trunc(this.props.balance*100),
          },
          requestPayerName : true,
          requestPayerEmail : true,
        });

        this.paymentRequest.on('token', ({complete, token, ...data}) => {
          this.props.onPayment(complete, this.props.balance, token);
        });

        this.paymentRequest.canMakePayment().then((result) => {
          this.setState({canMakePayment: !!result});
          if (!!result) {
            if (typeof(this.props.onEnabled) === 'function') {
              this.props.onEnabled();
            }
          } else {
            if (typeof(this.props.onDisabled) === 'function') {
              this.props.onDisabled();
            }
          }
        });
      }
    }
  }

  componentDidMount() {
    this.checkPayment();
  }
  
  componentDidUpdate() {
    this.checkPayment();
  }
  
  
  render() {
    // const {classes} = this.props;

    if (this.state.canMakePayment) {
      return (
        <Stripe.PaymentRequestButtonElement
          options = {{
            style : {
              paymentRequestButton : {
                theme : 'light',
              }
            },
            paymentRequest: this.paymentRequest,
          }}/>
      );
    } else {
      return ('');
    }
  }
}

export default withStyles(styles)(PaymentButton);

